import { HeadingLabel, SubheadingLabel } from '@/styles/fonts'
import { GrandstandIcon } from '@grandstand-web/bally-web-shared/src/components/GrandstandIcon'
import { GrandstandLogo } from '@grandstand-web/bally-web-shared/src/components/GrandstandLogo'
import { usePurchasingDisabled } from '@grandstand-web/bally-web-shared/src/hooks/usePurchasingDisabled'
import { ActiveSubscriptionsResponse, PaymentMethodsResponse } from '@grandstand/presentation-models'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { GrandstandButton } from '../Buttons'
import SubscriptionTile from './SubscriptionTile'

type PackagesProps = {
  isDTCEntitled: boolean
  subscriptions: ActiveSubscriptionsResponse
  creditCardDetail: PaymentMethodsResponse[number] | null
}

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
`

const Header = styled(HeadingLabel)`
  border-bottom: 1px solid var(--divider-canvas);
  padding-bottom: 25px;
  padding-left: 25px;
  padding-top: 25px;
  cursor: pointer;
  div {
    float: left;
    top: 3px;
    right: 10px;
    position: relative;
  }
`
const StatusHeader = styled.div`
  margin-left: 25px;
  margin-top: 25px;
  font-weight: var(--bold);
`

const ArrowIcon = styled(GrandstandIcon)``

const SubmitButton = styled(GrandstandButton)``

const TopContainer = styled.div`
  background: url('/upper-background.png');
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--on-dark);
  text-align: center;
  gap: 16px;
  height: 300px;
`

const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 16px;
  height: 300px;
  span {
    font-weight: var(--bold);
  }
`

const renderStatusHeader = (status: string) => {
  let headerText
  switch (status) {
    case 'active':
      headerText = 'Active'
      break
    case 'canceled':
      headerText = 'Canceled'
      break
    case 'expired':
      headerText = ' Expired'
      break
    case 'paused':
      headerText = 'Paused'
      break
    default:
      headerText = 'Subscription'
  }
  return headerText
}

const renderSubscriptionTiles = (
  subscriptions: ActiveSubscriptionsResponse,
  creditCardDetail: PackagesProps['creditCardDetail']
) => {
  const subscriptionRenderOrder = ['active', 'paused', 'seasonal_paused', 'canceled', 'expired']
  return subscriptions
    .sort(
      (a, b) =>
        subscriptionRenderOrder.indexOf(a.subscription_status) - subscriptionRenderOrder.indexOf(b.subscription_status)
    )
    .map((subscription, i) => (
      <SubscriptionTile
        key={subscription.order_id}
        subscription={subscription}
        ccLast4Digits={creditCardDetail?.card_number}
      />
    ))
}

const Packages = ({ isDTCEntitled, subscriptions, creditCardDetail }: PackagesProps) => {
  const router = useRouter()
  const { isPurchasingDisabled } = usePurchasingDisabled()

  const handleBackClick = () => {
    router.back()
  }

  return (
    <MainContent>
      <Header onClick={handleBackClick} fontSize="4">
        <ArrowIcon icon="arrow_left" /> Packages
      </Header>
      {!subscriptions.length && (
        <>
          <TopContainer data-theme="dark">
            <div>
              <GrandstandLogo logoStyle="horiz" width="281px"></GrandstandLogo>
            </div>
            <SubheadingLabel fontSize="1">
              Start streaming now. Pick a package that&apos;s right for you.
            </SubheadingLabel>
            {!isPurchasingDisabled && (
              <SubmitButton
                buttonStyle="primary"
                buttonSize="md"
                onClick={() => {
                  router.push('/packages')
                }}
              >
                BROWSE PACKAGES
              </SubmitButton>
            )}
          </TopContainer>
          {subscriptions.length < 1 && !isPurchasingDisabled && (
            <BottomContainer>
              <SubheadingLabel fontSize="1">
                <span>Get in the game.</span>
                <br />
                See our lineup of available packages.
              </SubheadingLabel>
            </BottomContainer>
          )}
        </>
      )}
      {subscriptions && renderSubscriptionTiles(subscriptions, creditCardDetail)}
    </MainContent>
  )
}
export default Packages
